import { gql } from '@apollo/client';

export const CONTRACTORS = gql`
  query GetContractors($slug: String) {
    contractors(slug: $slug) {
      id
      name
      slug
    }
  }
`;
